import React, { Activity } from 'react';

import { Box } from '@vk-hr-tek/ui/Box';
import { ToTopButton } from '@vk-hr-tek/ui/ToTopButton';
import { useScrollToTop } from '@vk-hr-tek/ui/hooks';

import { useStyles } from './ContainerWithScrollToTopButton.styles';

/**
 * Свойства компонента {@link ContainerWithScrollToTopButton}
 */
interface ContainerWithScrollToTopButtonProps {
  /**
   * Отступ от верха при прокрутке к началу контейнера по нажатию кнопки.
   */
  scrollMargin: number;

  /**
   * Содержимое, отображаемое внутри контейнера.
   */
  children: React.ReactNode | React.ReactNode[];
}

/**
 * Контейнер с кнопкой прокрутки наверх.
 *
 * @public
 * @param scrollMargin - Отступ от верха при прокрутке к началу контейнера по нажатию кнопки.
 * @param children - Содержимое, отображаемое внутри контейнера.
 * @returns Компонент ContainerWithScrollToTopButton.
 *
 * @remarks
 *
 * Ссылка на свойства компонента {@link ContainerWithScrollToTopButtonProps}
 */
export const ContainerWithScrollToTopButton = ({
  scrollMargin,
  children,
}: ContainerWithScrollToTopButtonProps) => {
  const { classes } = useStyles({ scrollMargin });
  const { containerRef, showScrollButton, scrollToStart } = useScrollToTop();

  return (
    <Box>
      <Box
        className={classes.scrollTarget}
        ref={containerRef}
        position="absolute"
        width={20}
        height={20}
        top={0}
      />

      {children}

      <Activity mode={showScrollButton ? 'visible' : 'hidden'}>
        <ToTopButton scrollToStart={scrollToStart} />
      </Activity>
    </Box>
  );
};
